import React from "react";
import "./Skeleton.css";

export default function Skeleton({ className = "", style }) {
  return <div className={`client-skeleton ${className}`} style={style} />;
}
